module.exports = {
	'Init': require('./init'),
	'PaginationEvents': require('./paginationEvents'),
	'InsertResults': require('./insertResults'),
	'Search': require('./search')
};
